import { Auth, type User } from '@edge/spark/io-aws'

import saveUser from './saveUser'

import { LoginResponseTypes, type MutationResolvers } from '../../../generated/graphql'

const doCompleteNewPassword: MutationResolvers['doCompleteNewPassword'] = async (
    _root,
    { newPassword },
    { client },
) => {
    try {
        if (!client) {
            throw new Error('Missing client context')
        }

        if (!saveUser.user) {
            throw new Error('No saved login information')
        }

        const user = saveUser.user as User
        const username = user.username

        if (!username || typeof username !== 'string') {
            throw new Error('No saved login information (username)')
        }

        if (!newPassword) {
            throw new Error('Password cannot be blank')
        }

        const res = await Auth.completeNewPassword(user, newPassword)
        console.log('signIn completed', res)
        saveUser.user = null
        return { result: LoginResponseTypes.Success }
    } catch (error) {
        const message = error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error'
        console.error(error)
        return { result: LoginResponseTypes.Failure, message }
    }
}

export default doCompleteNewPassword
